import { applicationProgressModalComponent } from './components/applicationProgressModalComponent';
import { applicationQueuedLearnModalComponent } from './components/applicationQueuedLearnModalComponent';
import { applicationUpdatedModalComponent } from './components/applicationUpdatedModalComponent';
import { checkboxIconComponent } from './components/checkboxIconComponent';
import { checkboxOutlineBlankIconComponent } from './components/checkboxOutlineBlankIconComponent';
import { checkedIconComponent } from './components/checkedIconComponent';
import { circularProgressFullScreenComponent } from './components/circularProgressFullScreenComponent';
import { coapplicantEmploymentSectionComponent } from './components/coapplicantEmploymentSectionComponent';
import { coapplicantIncomeSectionComponent } from './components/coapplicantIncomeSectionComponent';
import { coapplicantPersonalSectionComponent } from './components/coapplicantPersonalSectionComponent';
import { coapplicantResidenceSectionComponent } from './components/coapplicantResidenceSectionComponent';
import { dropzoneComponent } from './components/dropzoneComponent';
import { employmentSectionComponent } from './components/employmentSectionComponent';
import { headerComponent } from './components/headerComponent';
import { incomeSectionComponent } from './components/incomeSectionComponent';
import { landerImageComponent } from './components/landerImageComponent';
import { loanDocumentListComponent } from './components/loanDocumentListComponent';
import { loanDocumentUploadedListComponent } from './components/loanDocumentUploadedList';
import { mailCodeOfferComponent } from './components/mailCodeOfferComponent';
import { navigationPaneComponent } from './components/navigationPaneComponent';
import { personalSectionComponent } from './components/personalSectionComponent';
import { rateComponent } from './components/rateComponent';
import { refandiBannerComponent } from './components/refandiBannerComponent';
import { residenceSectionComponent } from './components/residenceSectionComponent';
import { uncheckedIconComponent } from './components/uncheckedIconComponent';
import { activationPage } from './pages/activationPage';
import { activationPinVerifyPage } from './pages/activationPinVerifyPage';
import { applicantAddCoapplicantPage } from './pages/applicantAddCoapplicantPage';
import { applicantAdditionalIncomePage } from './pages/applicantAdditionalIncomePage';
import { applicantEditEmploymentPage } from './pages/applicantEditEmploymentPage';
import { applicantEditIncomePage } from './pages/applicantEditIncomePage';
import { applicantEditPersonalPage } from './pages/applicantEditPersonalPage';
import { applicantEditResidencePage } from './pages/applicantEditResidence';
import { applicantEmploymentDetailsPage } from './pages/applicantEmploymentDetailsPage';
import { applicantEmploymentDurationPage } from './pages/applicantEmploymentDurationPage';
import { applicantEmploymentStatusPage } from './pages/applicantEmploymentStatusPage';
import { applicantEmploymentTypePage } from './pages/applicantEmploymentTypePage';
import { applicantIncomeDetailsPage } from './pages/applicantIncomeDetailsPage';
import { applicantPage } from './pages/applicantPage';
import { applicantPreviousEmploymentPage } from './pages/applicantPreviousEmploymentPage';
import { applicantPreviousResidencePage } from './pages/applicantPreviousResidencePage';
import { applicantResidenceDetailsPage } from './pages/applicantResidenceDetailsPage';
import { applicantResidenceDurationPage } from './pages/applicantResidenceDurationPage';
import { applicantResidenceTypePage } from './pages/applicantResidenceTypePage';
import { applicantReviewPage } from './pages/applicantReviewPage';
import { applicantSubmitPage } from './pages/applicantSubmitPage';
import { applicantSuccessPage } from './pages/applicantSuccessPage';
import { applicantUnemploymentDetailsPage } from './pages/applicantUnemploymentDetailsPage';
import { applicantUnemploymentTypePage } from './pages/applicantUnemploymentTypePage';
import { applicationUpdatePage } from './pages/applicationUpdatePage';
import { applyApplicationTypePage } from './pages/applyApplicationTypePage';
import { applyConfirmVehiclePage } from './pages/applyConfirmVehiclePage';
import { applyPage } from './pages/applyPage';
import { applyPurchaseTypePage } from './pages/applyPurchaseTypePage';
import { applyRefinanceGoalPage } from './pages/applyRefinanceGoalPage';
import { applySearchMakePage } from './pages/applySearchMakePage';
import { applySearchModelPage } from './pages/applySearchModelPage';
import { applySearchPlatePage } from './pages/applySearchPlatePage';
import { applySearchVehiclePage } from './pages/applySearchVehiclePage';
import { applySearchVinPage } from './pages/applySearchVinPage';
import { applySearchYearPage } from './pages/applySearchYearPage';
import { applyVehicleConditionPage } from './pages/applyVehicleConditionPage';
import { applyVehicleSelectionPage } from './pages/applyVehicleSelectionPage';
import { coapplicantAdditionalIncomePage } from './pages/coapplicantAdditionalIncomePage';
import { coapplicantDifferentResidencePage } from './pages/coapplicantDifferentResidencePage';
import { coapplicantDifferentResidenceTypePage } from './pages/coapplicantDifferentResidenceTypePage';
import { coapplicantEditEmploymentPage } from './pages/coapplicantEditEmploymentPage';
import { coapplicantEditIncomePage } from './pages/coapplicantEditIncomePage';
import { coapplicantEditPersonalPage } from './pages/coapplicantEditPersonalPage';
import { coapplicantEditResidencePage } from './pages/coapplicantEditResidencePage';
import { coapplicantEmploymentDetailsPage } from './pages/coapplicantEmploymentDetailsPage';
import { coapplicantEmploymentDurationPage } from './pages/coapplicantEmploymentDurationPage';
import { coapplicantEmploymentStatusPage } from './pages/coapplicantEmploymentStatusPage';
import { coapplicantEmploymentTypePage } from './pages/coapplicantEmploymentTypePage';
import { coapplicantIncomeDetailsPage } from './pages/coapplicantIncomeDetailsPage';
import { coapplicantPersonalDetailsPage } from './pages/coapplicantPersonalDetailsPage';
import { coapplicantPreviousEmploymentPage } from './pages/coapplicantPreviousEmploymentPage';
import { coapplicantPreviousResidencePage } from './pages/coapplicantPreviousResidencePage';
import { coapplicantRelationshipPage } from './pages/coapplicantRelationshipPage';
import { coapplicantResidenceDurationPage } from './pages/coapplicantResidenceDurationPage';
import { coapplicantResidenceRelationshipPage } from './pages/coapplicantResidenceRelationshipPage';
import { coapplicantReviewPage } from './pages/coapplicantReviewPage';
import { coapplicantSameResidencePage } from './pages/coapplicantSameResidencePage';
import { coapplicantUnemploymentDetailsPage } from './pages/coapplicantUnemploymentDetailsPage';
import { coapplicantUnemploymentTypePage } from './pages/coapplicantUnemploymentTypePage';
import { dashboardApplicationPage } from './pages/dashboardApplicationPage';
import { dashboardGaragePage } from './pages/dashboardGaragePage';
import { duplicateApplicationPage } from './pages/duplicateApplicationPage';
import { loanDocumentListPage } from './pages/loanDocumentListPage';
import { loanDocumentMileagePage } from './pages/loanDocumentMileagePage';
import { loanDocumentPage } from './pages/loanDocumentPage';
import { loanDocumentSuccessPage } from './pages/loanDocumentSuccessPage';
import { loanDocumentUploadAllPage } from './pages/loanDocumentUploadAllPage';
import { loanDocumentUploadPage } from './pages/loanDocumentUploadPage';
import { mailCodeActivationPage } from './pages/mailCodeActivationPage';
import { mailCodeOfferPage } from './pages/mailCodeOfferPage';
import { mailCodePage } from './pages/mailCodePage';
import { mailCodePinVerifyPage } from './pages/mailCodePinVerifyPage';
import { notFoundPage } from './pages/notFoundPage';
import { previewActivationPage } from './pages/previewActivationPage';
import { previewOfferPage } from './pages/previewOfferPage';
import { previewPinVerifyPage } from './pages/previewPinVerifyPage';
import { signInPage } from './pages/signInPage';
import { signInPinVerifyPage } from './pages/signInPinVerifyPage';
import { signOutPage } from './pages/signOutPage';
import { signUpPage } from './pages/signUpPage';
import { signUpPinVerifyPage } from './pages/signUpPinVerifyPage';
import { signUpReturningUserPage } from './pages/signUpReturningUserPage';
import { vehicleConfirmationPage } from './pages/vehicleConfirmationPage';
import { verificationDocumentListPage } from './pages/verificationDocumentListPage';
import { verificationPage } from './pages/verificationPage';
import { verificationUploadPage } from './pages/verificationUploadPage';
import { LocatorTree } from './types/LocatorTree';

export const locator = {
  components: {
    applicationProgressModal: applicationProgressModalComponent,
    applicationQueuedLearnModal: applicationQueuedLearnModalComponent,
    applicationUpdateModal: applicationUpdatedModalComponent,
    checkboxIcon: checkboxIconComponent,
    checkboxOutlineBlankIcon: checkboxOutlineBlankIconComponent,
    checkedIcon: checkedIconComponent,
    circularProgressFullScreen: circularProgressFullScreenComponent,
    coapplicantEmploymentSection: coapplicantEmploymentSectionComponent,
    coapplicantIncomeSection: coapplicantIncomeSectionComponent,
    coapplicantPersonalSection: coapplicantPersonalSectionComponent,
    coapplicantResidenceSection: coapplicantResidenceSectionComponent,
    dropzone: dropzoneComponent,
    employmentSection: employmentSectionComponent,
    header: headerComponent,
    incomeSection: incomeSectionComponent,
    landerImage: landerImageComponent,
    loanDocumentList: loanDocumentListComponent,
    loanDocumentUploadedList: loanDocumentUploadedListComponent,
    mailCodeOffer: mailCodeOfferComponent,
    navigationPane: navigationPaneComponent,
    personalSection: personalSectionComponent,
    rate: rateComponent,
    refandiBanner: refandiBannerComponent,
    residenceSection: residenceSectionComponent,
    uncheckedIcon: uncheckedIconComponent,
  },
  pages: {
    activation: activationPage,
    activationPinVerify: activationPinVerifyPage,
    applicant: applicantPage,
    applicantAddCoapplicant: applicantAddCoapplicantPage,
    applicantAdditionalIncome: applicantAdditionalIncomePage,
    applicantEditEmployment: applicantEditEmploymentPage,
    applicantEditIncome: applicantEditIncomePage,
    applicantEditPersonal: applicantEditPersonalPage,
    applicantEditResidence: applicantEditResidencePage,
    applicantEmploymentDetails: applicantEmploymentDetailsPage,
    applicantEmploymentDuration: applicantEmploymentDurationPage,
    applicantEmploymentStatus: applicantEmploymentStatusPage,
    applicantEmploymentType: applicantEmploymentTypePage,
    applicantIncomeDetails: applicantIncomeDetailsPage,
    applicantPreviousEmployment: applicantPreviousEmploymentPage,
    applicantPreviousResidence: applicantPreviousResidencePage,
    applicantResidenceDetails: applicantResidenceDetailsPage,
    applicantResidenceDuration: applicantResidenceDurationPage,
    applicantResidenceType: applicantResidenceTypePage,
    applicantReview: applicantReviewPage,
    applicantSubmit: applicantSubmitPage,
    applicantSuccess: applicantSuccessPage,
    applicantUnemploymentDetails: applicantUnemploymentDetailsPage,
    applicantUnemploymentType: applicantUnemploymentTypePage,
    applicationUpdate: applicationUpdatePage,
    apply: applyPage,
    applyApplicationType: applyApplicationTypePage,
    applyConfirmVehicle: applyConfirmVehiclePage,
    applyPurchaseType: applyPurchaseTypePage,
    applyRefinanceGoal: applyRefinanceGoalPage,
    applySearchMake: applySearchMakePage,
    applySearchModel: applySearchModelPage,
    applySearchPlate: applySearchPlatePage,
    applySearchVehicle: applySearchVehiclePage,
    applySearchVin: applySearchVinPage,
    applySearchYear: applySearchYearPage,
    applyVehicleCondition: applyVehicleConditionPage,
    applyVehicleSelection: applyVehicleSelectionPage,
    coapplicantAdditionalIncome: coapplicantAdditionalIncomePage,
    coapplicantDifferentResidence: coapplicantDifferentResidencePage,
    coapplicantDifferentResidenceType: coapplicantDifferentResidenceTypePage,
    coapplicantEditEmployment: coapplicantEditEmploymentPage,
    coapplicantEditIncome: coapplicantEditIncomePage,
    coapplicantEditPersonal: coapplicantEditPersonalPage,
    coapplicantEditResidence: coapplicantEditResidencePage,
    coapplicantEmploymentDetails: coapplicantEmploymentDetailsPage,
    coapplicantEmploymentDuration: coapplicantEmploymentDurationPage,
    coapplicantEmploymentStatus: coapplicantEmploymentStatusPage,
    coapplicantEmploymentType: coapplicantEmploymentTypePage,
    coapplicantIncomeDetails: coapplicantIncomeDetailsPage,
    coapplicantPersonalDetails: coapplicantPersonalDetailsPage,
    coapplicantPreviousEmployment: coapplicantPreviousEmploymentPage,
    coapplicantPreviousResidence: coapplicantPreviousResidencePage,
    coapplicantRelationship: coapplicantRelationshipPage,
    coapplicantResidenceDuration: coapplicantResidenceDurationPage,
    coapplicantResidenceRelationship: coapplicantResidenceRelationshipPage,
    coapplicantReview: coapplicantReviewPage,
    coapplicantSameResidence: coapplicantSameResidencePage,
    coapplicantUnemploymentDetails: coapplicantUnemploymentDetailsPage,
    coapplicantUnemploymentType: coapplicantUnemploymentTypePage,
    dashboardApplication: dashboardApplicationPage,
    dashboardGarage: dashboardGaragePage,
    duplicateApplication: duplicateApplicationPage,
    loanDocument: loanDocumentPage,
    loanDocumentList: loanDocumentListPage,
    loanDocumentMileage: loanDocumentMileagePage,
    loanDocumentSuccess: loanDocumentSuccessPage,
    loanDocumentUpload: loanDocumentUploadPage,
    loanDocumentUploadAll: loanDocumentUploadAllPage,
    mailCode: mailCodePage,
    mailCodeActivation: mailCodeActivationPage,
    mailCodeOffer: mailCodeOfferPage,
    mailCodePinVerify: mailCodePinVerifyPage,
    notFound: notFoundPage,
    previewActivation: previewActivationPage,
    previewOffer: previewOfferPage,
    previewPinVerify: previewPinVerifyPage,
    signIn: signInPage,
    signInPinVerify: signInPinVerifyPage,
    signOut: signOutPage,
    signUp: signUpPage,
    signUpPinVerify: signUpPinVerifyPage,
    signUpReturningUser: signUpReturningUserPage,
    vehicleConfirmation: vehicleConfirmationPage,
    verification: verificationPage,
    verificationDocumentList: verificationDocumentListPage,
    verificationUpload: verificationUploadPage,
  },
} as const satisfies LocatorTree;
